import { Link, Text } from "@radix-ui/themes";
import { FC } from "react";

export const Imprint: FC = () => {
  return (
    <>
      <Text as="p">Alexander Bürkle GmbH & Co. KG</Text>
      <Text as="p">Robert-Bunsen-Str. 5</Text>
      <Text as="p">79108 Freiburg im Breisgau</Text>
      <Text as="p">Handelsregister: HRA 38</Text>
      <Text as="p">Registergericht: Amtsgericht Freiburg im Breisgau</Text>
      <br />
      <Text as="p" weight={"bold"}>
        Vertreten durch:
      </Text>
      <Text as="p">Alexander Bürkle Verwaltungs-GmbH</Text>
      <br />
      <Text as="p" weight={"bold"}>
        Diese vertreten durch:
      </Text>
      <Text as="p">
        Andreas Ege, Klemens Isenmann, Sascha Liese, Simon Straub
      </Text>
      <Text as="p">Handelsregister: HRB 706450</Text>
      <Text as="p">Registergericht: Amtsgericht Freiburg im Breisgau</Text>
      <br />
      <Text as="p" weight={"bold"}>
        Kontakt:
      </Text>
      <Text as="p">Telefon: +49 761 5106-0</Text>
      <Text as="p">Telefax: +49 761 5106-990</Text>
      <Text as="p">
        <Link href="mailto:info@alexander-buerkle.de">
          E-Mail: info@alexander-buerkle.de
        </Link>
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Umsatzsteuer-ID:
      </Text>
      <Text as="p">
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
        DE142099658
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Redaktionell Verantwortlicher:
      </Text>
      <Text as="p">Andreas Ege</Text>
      <Text as="p">Alexander Bürkle GmbH & Co. KG</Text>
      <Text as="p">Robert-Bunsen-Str. 5</Text>
      <Text as="p">79108 Freiburg im Breisgau</Text>
      <br />
      <Text as="p" weight={"bold"}>
        Allgemeine Liefer- & Zahlungsbedingungen
      </Text>
      <Text as="p">
        Auf unserer Seite AGB haben wir Ihnen alle diesbezüglichen Informationen
        zum Download bereitgestellt.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Datenschutz
      </Text>
      <Text as="p">
        Unsere Informationen zum Datenschutz finden Sie direkt auf dieser Seite.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        EU-Streitschlichtung
      </Text>
      <Text as="p">
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit:{" "}
        <Link href="https://ec.europa.eu/consumers/odr" target="_blank">
          https://ec.europa.eu/consumers/odr
        </Link>
      </Text>
      <Text as="p">Unsere E-Mail-Adresse finden Sie oben im Impressum.</Text>
      <br />
      <Text as="p" weight={"bold"}>
        Verbraucherstreitbeilegung / Universalschlichtungsstelle
      </Text>
      <Text as="p">
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
        vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Haftung für Inhalte
      </Text>
      <Text as="p">
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf
        diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8
        bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
        übermittelte oder gespeicherte fremde Informationen zu überwachen oder
        nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
        hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
        Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
        Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
        Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
        entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
        entfernen.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Haftung für Links
      </Text>
      <Text as="p">
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
        Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
        waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
        inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
        Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden
        von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Urheberrecht
      </Text>
      <Text as="p">
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
        sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
        werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
        Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
        entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
        wir derartige Inhalte umgehend entfernen.
      </Text>
    </>
  );
};
